/* Maternity and MCH (docs/plans/phase2-maternity-mch.md §6). Tokens only; `danger` only for
 * clinical danger (a danger sign ticked). Charts are ink on paper, no colour. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.numeric {
  font-variant-numeric: tabular-nums;
}

.danger {
  color: var(--danger);
  font: var(--t-body-strong);
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(11rem, 1fr));
  gap: var(--space-3) var(--space-4);
}

.fieldset {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}

.legend {
  padding: 0;
  font: var(--t-body-strong);
}

.checks {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(16rem, 1fr));
  gap: var(--space-2) var(--space-4);
}

.when {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3) var(--space-4);
  align-items: flex-start;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.links {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-4);
}

.facts {
  display: grid;
  grid-template-columns: max-content minmax(0, 1fr);
  gap: var(--space-2) var(--space-5);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
}

.facts dd {
  margin: 0;
}

.baby {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-top: var(--space-4);
  border-top: 1px solid var(--rule);
}

.chart {
  width: 100%;
  height: auto;
  max-height: 20rem;
}

.chartAxis {
  stroke: var(--border-strong);
  stroke-width: 1;
}

.chartGrid {
  stroke: var(--rule);
  stroke-width: 1;
}

.chartLine {
  fill: none;
  stroke: var(--ink);
  stroke-width: 2;
}

.chartGuide {
  fill: none;
  stroke: var(--graphite);
  stroke-width: 1.5;
  stroke-dasharray: 6 4;
}

.chartPoint {
  fill: var(--ink);
}

.chartHollow {
  fill: var(--paper);
  stroke: var(--ink);
  stroke-width: 2;
}

.chartLabel {
  fill: var(--graphite);
  font: var(--t-micro);
}

.struck {
  text-decoration: line-through;
}
